import { Heading } from '@hungryroot/ramen';
import { getSectionId, type SectionListData } from './utils';
import styles from './SectionList.module.css';

interface Props {
  testid?: string;
  data: SectionListData;
}

function getSectionList(data: SectionListData) {
  return Object.keys(data).map((key) => {
    const section = data[key as keyof typeof data];
    const { title, body } = section;

    return (
      <li
        data-testid={`item-${key}`}
        id={getSectionId(data, key)}
        key={key}
        className={styles['item-primary']}
      >
        <Heading variant="H5" className={styles['item-title']}>
          {title}
        </Heading>
        {body}
      </li>
    );
  });
}

export function SectionList(props: Props) {
  const { testid, data } = props;

  return (
    <ol data-testid={testid} className={styles['primary-list']}>
      {getSectionList(data)}
    </ol>
  );
}
